var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.49998V4.49998C10.5 4.89781 10.658 5.27934 10.9393 5.56064C11.2206 5.84195 11.6022 5.99998 12 5.99998H15M9 13.5V8.99998M9 13.5L6.75 11.25M9 13.5L11.25 11.25M11.25 1.49998H4.5C4.10218 1.49998 3.72064 1.65802 3.43934 1.93932C3.15804 2.22063 3 2.60216 3 2.99998V15C3 15.3978 3.15804 15.7793 3.43934 16.0606C3.72064 16.3419 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.3419 14.5607 16.0606C14.842 15.7793 15 15.3978 15 15V5.24998L11.25 1.49998Z",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDown);
export default __webpack_public_path__ + "static/media/file-down.309bcb85bfc9513b4297bc2b5e42a9d5.svg";
export { ForwardRef as ReactComponent };